import { styled } from '@mui/material/styles';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

// Styled Linear Progress component
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#D0D0D0', // Progress background color
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#0486D7', // Filled progress color
  },
}));

const Container = styled(Box)(({ theme }) => ({
  width: theme.spacing(75),
  margin: `0 auto ${theme.spacing(10)}`,
  padding: theme.spacing(1.25, 0),

  [theme.breakpoints.down('xl')]: {
    width: theme.spacing(70),
    margin: `0 auto ${theme.spacing(10)}`,
  },

  [theme.breakpoints.down('lg')]: {
    width: theme.spacing(62),
    margin: `0 auto ${theme.spacing(9)}`,
  },

  [theme.breakpoints.down('md')]: {
    width: theme.spacing(45),
    margin: `0 auto ${theme.spacing(7)}`,
  },
}));

const StepperProgress = ({ currentStep, totalSteps }) => {
  // Calculate progress percentage
  // For step 1: 33.33%, step 2: 66.67%, step 3: 100%
  const progressValue = ((currentStep + 1) / totalSteps) * 100;

  return (
    <Container>
      <BorderLinearProgress variant="determinate" value={progressValue} />
    </Container>
  );
};

export default StepperProgress;
